import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3d94de14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { className: "tabs" }

import { refundUrl } from '../../envVariables';
import { RteContentType, SailingStatusType } from '../../types';
import {
  SailingTabView,
  ServiceTabView,
  InformationTabView,
  Tabs,
  Tab,
} from '../../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusTabs',
  props: {
    sailingStatusReports: {},
    serviceStatuses: {},
    informationStatuses: {},
    onFindAlternateClick: { type: Function }
  },
  setup(__props: any) {



const onRefundClick = () => {
  window.open(refundUrl);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tabs), null, {
      default: _withCtx(() => [
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Sailings')
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sailingStatusReports, (item, i) => {
              return (_openBlock(), _createBlock(_unref(SailingTabView), {
                key: i,
                status: item.status,
                "status-heading": item.statusHeading ?? _ctx.$t('Service normal'),
                "rte-content": item.rteContent,
                "find-alternative-click": _ctx.onFindAlternateClick,
                "refund-click": () => onRefundClick(),
                "show-alternative-cta": item.showAlternativeCta,
                "show-refund-cta": item.showRefundCta
              }, null, 8, ["status", "status-heading", "rte-content", "find-alternative-click", "refund-click", "show-alternative-cta", "show-refund-cta"]))
            }), 128)),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"]),
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Service')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ServiceTabView), {
              heading: _ctx.$t('Service'),
              "is-empty": 
            _ctx.serviceStatuses == undefined || _ctx.serviceStatuses.length === 0
          ,
              "rte-content": _ctx.serviceStatuses
            }, null, 8, ["heading", "is-empty", "rte-content"]),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"]),
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Information')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(InformationTabView), {
              heading: _ctx.$t('Information'),
              "rte-content": _ctx.informationStatuses,
              "is-empty": 
            _ctx.informationStatuses == undefined || _ctx.informationStatuses.length === 0
          
            }, null, 8, ["heading", "rte-content", "is-empty"]),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"])
      ]),
      _: 3
    })
  ]))
}
}

})